webpackJsonp([142629428675168],{

/***/ 356:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulPage":{"title":"Hem","slug":"hem","metaDescription":{"internal":{"content":"Litet, klassiskt hotell i Änggården, Göteborg"}},"body":{"childMarkdownRemark":{"html":"<p>I det vackra villaområdet Änggården ligger Aston Villa – det lilla, personliga hotellet. I den arkitektritade funkisvillan bor du med promenadavstånd till Linnéstaden, Slottsskogen, Sahlgrenska sjukhuset och Göteborgs botaniska trädgård.</p>\n<p>Välkommen!</p>","excerpt":"I det vackra villaområdet Änggården ligger Aston Villa – det lilla, personliga hotellet. I den arkitektritade funkisvillan bor du med promenadavstånd till Linnéstaden, Slottsskogen, Sahlgrenska sjukhuset och Göteborgs botaniska trädgård. Välkommen!"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-a0d678f7000ed660da9a.js